import { FunctionalComponent, h } from '@stencil/core';
import state from '@ugc-store';

const ViewMobile: FunctionalComponent<{ productId: number }> = ({ productId }) => {
  const { ids = [], isReviewListLoaded, isShowReviewSkeleton, isEnableTagsV2, isEnableSummary, isLitePdp } = state;
  const isHaveReview = isReviewListLoaded && !!ids.length;

  const inlineReviewUrl = `${state.domains.catalog || ''}/ugc/inline/pr/${productId}/review`;
  const isEnabledTagsOrSummary = isEnableTagsV2 || isEnableSummary;

  return (
    <div class="ugc-global-css-wrap">
      <div class="ugc-pdp-review-section ugc-component-wrap relative">
        <link rel="prefetch" href={inlineReviewUrl} as="iframe" />
        <div>
          <div class={`bg-white py-16 px-16`}>
            {!isLitePdp && <ugc-authentic-banner />}
            <ugc-review-ratings productId={productId} />
            {isEnabledTagsOrSummary && <ugc-review-tagsv2 productId={productId} />}
          </div>
          <ugc-review-mw-all-images productId={productId} />
          <div
            class={
              isHaveReview && !isShowReviewSkeleton
                ? 'bg-white mt-8 mx-16 pb-16 border-bottom-solid border-1 border-gray-300'
                : ''
            }
          >
            <ugc-review-global-title />
            <ugc-page-summary productId={productId} />
          </div>
          <div class="px-16">
            <ugc-review-pending productId={productId} />
            <ugc-review-list productId={productId} />
            <ugc-review-no-data />
          </div>

          {!isLitePdp && (
            <div class={`bg-white p-16`}>
              <ugc-review-banner />
              <ugc-write-review-button />
            </div>
          )}
        </div>
        <ugc-review-scroll-ga />
        <ugc-review-mw-all-images-modal />
        <ugc-review-mw-all-images-detail-modal />
        <ugc-review-mw-image-modal />
        <ugc-review-learn-more-modal />
        <ugc-review-medal-modal />
        <ugc-review-rewarded-modal />
        <ugc-review-operate-modal />

        {/* mobile qna and review common component  */}
        <ugc-report-abuse-modal />
        <ugc-share-modal />
        <ugc-alert />
        <ugc-action-permission action={['review', 'question', 'answer', 'vote']} productId={productId} />
        <ugc-perimeterx-modal />
        <ugc-product productId={productId} />
      </div>
    </div>
  );
};

export default ViewMobile;
